import React, { useState, useContext } from "react";
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next";
import MenuToolTipBody, {
  MenuToolTipBodyItem,
} from "components/Design/MenuToolTipBody/MenuTooltipBody";
import { TopBarItem } from "components/TopBar";
import Drawer from "components/Design/Drawer/Drawer";
import DrawerHead from "components/Design/Card/DrawerHead";
import {
  MenuOptionsList,
  MenuOption,
} from "components/Design/MenuList/MenuOptions";
import PageContext from "contexts/PageContext";
import { SITE_LANGUAGES } from "store/constants/languages";
import Tooltip from "./Design/Tooltip/Tooltip";

const languageFullname = {
  en: "English",
  zh: "中文",
  ja: "日本語",
  ko: "한국어",
};

const languageName = {
  en: "ENG",
  zh: "CHI",
  ja: "JPN",
  ko: "KOR",
};

const LanguageSelectorMenu = () => {
  const { reason, destination, subDestination, tabActive } =
    useContext(PageContext);
  const { language, languages, changeLanguage } = useI18next();
  const [langValue, setLangValue] = useState(language);
  const { t } = useTranslation();

  const handleClick = (languageCode) => {
    setLangValue(languageCode);
    changeLanguage(languageCode, "", {
      state: {
        reason: reason,
        destination: destination,
        subDestination: subDestination,
        tabActive: tabActive,
      },
    });
  };

  return (
    <Tooltip
      trigger={<TopBarItem>{t(languageName[language])}</TopBarItem>}
      openOnHover>
      <div className="text-black capitalize">
        <MenuToolTipBody>
          {SITE_LANGUAGES.map((lang) => (
            <MenuToolTipBodyItem
              key={lang}
              selected={lang === langValue}
              onClick={() => handleClick(lang)}>
              {languageFullname[lang]}
            </MenuToolTipBodyItem>
          ))}
        </MenuToolTipBody>
      </div>
    </Tooltip>
  );
};

const LanguageSelectorDrawer = ({ visible, onClose }) => {
  const { reason, destination, subDestination, tabActive } =
    useContext(PageContext);
  const { t } = useTranslation();
  const { language, languages, changeLanguage } = useI18next();
  const [langValue, setLangValue] = useState(language);

  const handleClick = (languageCode) => {
    setLangValue(languageCode);
    changeLanguage(languageCode, "", {
      state: {
        reason: reason,
        destination: destination,
        subDestination: subDestination,
        tabActive: tabActive,
      },
    });
  };

  return (
    <div>
      <Drawer placement="bottom" visible={visible} onClose={onClose}>
        <DrawerHead title={t("Language")} onClose={onClose} />
        <MenuOptionsList>
          {SITE_LANGUAGES.map((lang) => (
            <MenuOption
              key={lang}
              selected={lang === langValue}
              onClick={() => handleClick(lang)}>
              {languageFullname[lang]}
            </MenuOption>
          ))}
        </MenuOptionsList>
      </Drawer>
    </div>
  );
};

export { LanguageSelectorMenu, LanguageSelectorDrawer };
